import { render, staticRenderFns } from "./garden29.vue?vue&type=template&id=1d767b13&scoped=true"
import script from "./garden29.vue?vue&type=script&lang=js"
export * from "./garden29.vue?vue&type=script&lang=js"
import style0 from "./garden29.vue?vue&type=style&index=0&id=1d767b13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d767b13",
  null
  
)

export default component.exports